// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CoverMyMedsInboundEnrollmentAddressModel {
    static getAttributeTypeMap() {
        return CoverMyMedsInboundEnrollmentAddressModel.attributeTypeMap;
    }
}
CoverMyMedsInboundEnrollmentAddressModel.discriminator = undefined;
CoverMyMedsInboundEnrollmentAddressModel.additionalProperties = false;
CoverMyMedsInboundEnrollmentAddressModel.attributeTypeMap = [
    {
        "name": "address1",
        "baseName": "address1",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "zipCode",
        "baseName": "zipCode",
        "type": "string"
    },
];
//# sourceMappingURL=coverMyMedsInboundEnrollmentAddressModel.js.map